'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import Checkbox from 'components/consumer/Checkbox';
const DEFAULT_LIMIT = 10;
const SHOW_MORE_LIMIT = 500;
const ProductTypeRefinementList = () => {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      attribute: "type",
      limit: SHOW_MORE_LIMIT
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    items,
    refine
  } = useRefinementList(t0);
  const [showMore, setShowMore] = useState(false);
  let t1;
  if ($[1] !== items) {
    t1 = items?.filter(_temp) || [];
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const itemsWithHits = t1;
  let t2;
  if ($[3] !== itemsWithHits) {
    t2 = itemsWithHits?.some(_temp2) || false;
    $[3] = itemsWithHits;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isAnyRefined = t2;
  let t3;
  if ($[5] !== isAnyRefined || $[6] !== itemsWithHits) {
    let t4;
    if ($[8] !== isAnyRefined) {
      t4 = item_1 => !isAnyRefined || item_1.isRefined;
      $[8] = isAnyRefined;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = itemsWithHits.filter(t4);
    $[5] = isAnyRefined;
    $[6] = itemsWithHits;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const validItems = t3;
  let t4;
  if ($[10] !== showMore || $[11] !== validItems) {
    t4 = showMore ? validItems : validItems.slice(0, DEFAULT_LIMIT);
    $[10] = showMore;
    $[11] = validItems;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const displayedItems = t4;
  const hasMore = validItems.length > DEFAULT_LIMIT;
  let t5;
  if ($[13] !== displayedItems || $[14] !== refine) {
    let t6;
    if ($[16] !== refine) {
      t6 = item_2 => <li key={item_2.value} className="cursor-pointer mt-4"><Checkbox id={`product-type-${item_2.value}`} checked={item_2.isRefined} onClick={() => refine(item_2.value)} size="sm" className="group flex relative cursor-pointer"><span className="[&_a]:text-brand [&_a]:z-[2] [&_a]:focus:underline group-hover:text-brand text-gray pl-1 text-sm mt-px">{item_2.label}</span></Checkbox></li>;
      $[16] = refine;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t5 = displayedItems.map(t6);
    $[13] = displayedItems;
    $[14] = refine;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[18] !== t5) {
    t6 = <ul className="list-none p-0 m-0">{t5}</ul>;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== hasMore || $[21] !== showMore) {
    t7 = hasMore && <button type="button" onClick={() => setShowMore(!showMore)} className="text-sm font-bold text-brand mt-3 bg-transparent border-0 cursor-pointer p-0 font-sans">{showMore ? "Show less" : "Show more"}</button>;
    $[20] = hasMore;
    $[21] = showMore;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div className="[&_.group>span:first-of-type]:rounded">{t6}{t7}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
export default ProductTypeRefinementList;
function _temp(item) {
  return item.count > 0;
}
function _temp2(item_0) {
  return item_0.isRefined;
}